import React from 'react';
import Button from 'react-bootstrap/Button';
import CustomModal from '../../../common/components/modal/CustomModal';
import {FormikProps} from 'formik';
import LoginAsCustomerFormLogic from './LoginAsCustomerFormLogic';
import {LoginAsCustomerFormValues} from '../../../interfaces/login';
import {useIntl} from 'react-intl';

interface LoginAsCustomerModalProps {
  show: boolean;
  hide: () => void;
  formik: FormikProps<LoginAsCustomerFormValues>;
  isLoading?: boolean;
}

const LoginAsCustomerModal = ({
  show,
  hide,
  formik,
  isLoading = false,
}: LoginAsCustomerModalProps): JSX.Element => {
  const intl = useIntl();

  return (
    <CustomModal
      title={intl.formatMessage({id: 'CUSTOMER_SCOPE.MODAL_TITLE'})}
      show={show}
      onHide={hide}
      body={<LoginAsCustomerFormLogic formik={formik} />}
      footer={
        <>
          <Button
            variant="secondary"
            onClick={() => {
              hide();
            }}
          >
            {intl.formatMessage({id: 'CANCEL'})}
          </Button>
          <Button
            disabled={isLoading || !formik.isValid}
            variant="celeste-primary"
            onClick={() => {
              formik.submitForm();
            }}
          >
            {intl.formatMessage({id: 'CUSTOMER_SCOPE.SUBMIT'})}
          </Button>
        </>
      }
    />
  );
};

export default LoginAsCustomerModal;
